<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="!isFormDisplayed()" hideToggle class="panel-list" [ngClass]="{ expanded: isFormDisplayed() }" [disabled]="true">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !isFormDisplayed(), 'events-active': isFormDisplayed() }"
            class="detail-header">
            <app-list-header
                [createRight]="false"
                titleText="Applications"
                createIconText=""
                (exported)="onApplicationsExported()"
                (helped)="onApplicationsHelped()"
                (listDisplayed)="setDisplayMode(DisplayMode.List)"
                (treeDisplayed)="setDisplayMode(DisplayMode.Tree)"></app-list-header>
        </mat-expansion-panel-header>

        @if (isListDisplayed()) {
            <app-applications-list
                (itemSelected)="onApplicationSelected($event)"
                (itemDisplayed)="onApplicationDisplayed($event)"
                (itemEdited)="onApplicationEdited($event)"
                (itemReseted)="onApplicationReseted($event)"></app-applications-list>
        }
    </mat-expansion-panel>

    @if (isFormDisplayed()) {
        <mat-expansion-panel [expanded]="isFormDisplayed()" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.applicationContext.item.displayName"
                    [id]="context?.applicationContext.item.id"
                    (displayed)="onApplicationDisplayed(context?.applicationContext.item)"
                    (edited)="onApplicationEdited(context?.applicationContext.item)"
                    (helped)="onApplicationsHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-applications-detail [context]="context" (applicationUpdated)="applicationUpdated($event)" (canceled)="onBackToList()"></app-applications-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
